import { Badge } from "@/components/ui/badge"
import * as Card from "@/components/ui/card"
import { Text } from "@/components/ui/text"
import SimpleRichText from "@components/SimpleRichText"
import { For, Show } from "solid-js"
import { Flex, Grid } from "styled-system/jsx"
import Option from "./Option"

interface QuizQuestionCardProps {
  question: any
  isReview: boolean
  submission?: any
  selectedIndices: number[]
  onToggleSelection: (optionIndex: number, isMulti: boolean) => void
}

export default function QuizQuestionCard(props: QuizQuestionCardProps) {
  return (
    <Card.Root p={6}>
      <Flex justify="space-between" mb={4}>
        <Text fontWeight="semibold" color="fg.muted">
          {props.question.correct_indices.length > 1 ? "Select all that apply" : "Select one answer"}
        </Text>
        <Show when={props.isReview && props.submission}>
          <Badge colorPalette={props.submission.is_correct ? 'jade' : 'red'}>
            {props.submission.is_correct ? 'Correct' : 'Incorrect'}
          </Badge>
        </Show>
      </Flex>

      <SimpleRichText content={props.question.prompt} />

      <Grid gap={3}>
        <For each={props.question.options as string[]}>
          {(option, index) => {
            const isMulti = props.question.correct_indices.length > 1

            return (
              <Option
                option={option}
                isMulti={isMulti}
                isReview={props.isReview}
                // Because Solid passes props as getters, these evaluate perfectly on every click!
                isSelectedActive={props.selectedIndices.includes(index())}
                isSelectedReview={props.submission?.selected_indices.includes(index()) || false}
                isActuallyCorrect={props.question.correct_indices.includes(index())}
                onToggle={() => props.onToggleSelection(index(), isMulti)}
              />
            )
          }}
        </For>
      </Grid>
    </Card.Root>
  )
}
